/**
 * One-of-many choice within a named group.
 * Spec: assets/handoffs/design_system_export/specs/Radio.json
 *
 * Same `size` inference as Checkbox — the spec's dot.size/dot.sizeMd (16/20)
 * aren't tied to a named prop.
 *
 * @param {'sm'|'md'=sm} size
 * @param {boolean=false} checked
 * @param {boolean=false} disabled
 * @param {string=} label
 * @param {string} name - required, groups radios together
 */
import React, { forwardRef } from "react";
import classNames from "classnames";
import styles from "./Radio.module.scss";

const Radio = forwardRef(
  ({ size = "sm", checked = false, disabled = false, label, className, id, ...rest }, ref) => {
    return (
      <label
        className={classNames(styles.root, { [styles["is-disabled"]]: disabled }, className)}
        htmlFor={id}
      >
        <span className={classNames(styles.dotWrap, styles[`dotWrap--${size}`])}>
          <input
            ref={ref}
            id={id}
            type="radio"
            className={styles.input}
            checked={checked}
            disabled={disabled}
            {...rest}
          />
          <span className={styles.dot} aria-hidden="true">
            {checked && <span className={styles.innerDot} />}
          </span>
        </span>
        {label && <span className={styles.label}>{label}</span>}
      </label>
    );
  }
);

Radio.displayName = "Radio";

export default Radio;
